import { render, staticRenderFns } from "./messageResend.vue?vue&type=template&id=1d3fd89c&scoped=true&"
import script from "./messageResend.vue?vue&type=script&lang=js&"
export * from "./messageResend.vue?vue&type=script&lang=js&"
import style0 from "./messageResend.vue?vue&type=style&index=0&id=1d3fd89c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3fd89c",
  null
  
)

export default component.exports